<script setup lang="ts">
import { computed } from "vue";
import { RouterLink, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import SiteFooter from "../components/SiteFooter.vue";
import { getLegalDocument, type LegalDocumentType } from "../legal-content";

const route = useRoute();
const { t } = useI18n();

const documentType = computed<LegalDocumentType>(() => (route.path.includes("terms") ? "terms" : "privacy"));
const documentContent = computed(() => getLegalDocument(documentType.value));
</script>

<template>
  <main class="legal-shell">
    <section class="legal-document">
      <RouterLink class="legal-back-link" to="/login">{{ t("common.brand") }}</RouterLink>
      <p class="eyebrow">{{ documentContent.effectiveDate }}</p>
      <h1>{{ documentContent.title }}</h1>
      <p class="legal-subtitle">{{ documentContent.subtitle }}</p>

      <div class="legal-intro">
        <p v-for="paragraph in documentContent.intro" :key="paragraph">{{ paragraph }}</p>
      </div>

      <section v-for="section in documentContent.sections" :key="section.title" class="legal-section">
        <h2>{{ section.title }}</h2>
        <p v-for="paragraph in section.paragraphs" :key="paragraph">{{ paragraph }}</p>
      </section>

      <div class="legal-actions">
        <RouterLink to="/privacy">{{ t("footer.privacy") }}</RouterLink>
        <RouterLink to="/terms">{{ t("footer.terms") }}</RouterLink>
      </div>
    </section>
    <SiteFooter />
  </main>
</template>
